import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Role } from '../../models';
import { RolePermission } from '../../models/role-permission';
import { RoleTenancy } from '../../models/role-tenancy';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends UzurvRestService {
  readonly resourceUrl = 'roles/';
  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of available roles
   *
   * @param pageNumber
   * @param pageSize
   * @permission role_management
   */
  getRoles(pageNumber: number, pageSize: number): Observable<Array<Role>> {
    return this.get<Array<Role>>(this.resourceUrl, {
      pageNumber: pageNumber,
      pageSize: pageSize
    }).pipe(map(response => Deserialize(response, Role)));
  }

  /**
   * @param id
   * @permission system_configuration
   */
  listRolePermissionsByRoleId(id: number): Observable<Array<RolePermission>> {
    return this.get<Array<RoleTenancy>>(`${this.resourceUrl}${id}/permissions/`).pipe(
      map(response => Deserialize(response, RolePermission))
    );
  }

  /**
   * @param id
   * @permission system_configuration
   */
  listRoleTenancyByRoleId(id: number): Observable<Array<RoleTenancy>> {
    return this.get<Array<RoleTenancy>>(`${this.resourceUrl}${id}/tenancies/`).pipe(map(response => Deserialize(response, RoleTenancy)));
  }

  /**
   * @param role
   * @permission system_configuration
   */
  save(role: Role): Observable<Role> {
    return this.post<Role>(this.resourceUrl, Serialize(role)).pipe(map(response => Deserialize(response, Role)));
  }

  /**
   * @param id
   * @param role
   * @permission system_configuration
   */
  update(id: number, role: Role): Observable<Role> {
    return this.put<Role>(`${this.resourceUrl}${id}`, Serialize(role)).pipe(map(response => Deserialize(response, Role)));
  }

  /**
   * @param id
   * @param permissionIds
   * @permission system_configuration
   */
  setRolePermissions(id: number, permissionIds: Array<number>): Observable<Array<RolePermission>> {
    return this.put<Array<RolePermission>>(`${this.resourceUrl}${id}/permissions/`, permissionIds).pipe(
      map(response => Deserialize(response, RolePermission))
    );
  }

  /**
   * @param id
   * @param tenantIds
   * @permission system_configuration
   */
  setRoleTenancies(id: number, tenantIds: Array<number>): Observable<Array<RoleTenancy>> {
    return this.put<Array<RoleTenancy>>(`${this.resourceUrl}${id}/tenancies/`, tenantIds).pipe(
      map(response => Deserialize(response, RoleTenancy))
    );
  }
}
